<template>
  <div v-if="showSettings" class="col-9 offset-sm-3 mt-2 mb-4">
    <div v-if="loading" class="col-12 d-flex  justify-content-center">
      <div class="spinner-border text-primary">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <template  v-else>
<!--      <div class="col-12">-->
<!--        <div class="form-group row">-->
<!--          <div class="col-sm-3">-->
<!--            <h4>Settings Configuration</h4>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="col-12">
        <div class="card-body badge-glow border-secondary" style="border-radius: .8rem">
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-12 mb-1">
                <button
                    type="button"
                    class="btn btn-outline-warning btn-sm mr-1"
                    @click="clearAllSettings"
                    :disabled="loading"
                >
                  Clear All Configurations
                </button>
              </div>
            </div>
            <div class="row">
              <div v-for="(field, index) in settlementConfigurations" :key="index" class="col-md-6">
                <div class="form-group">
                  <label v-if="field.type !== 'checkbox'" :for="field.name">{{ field.title }}</label>
                  <!-- Text Input -->
                  <input
                      v-if="(field.type === 'text' || field.type === 'number')"
                      :type="field.type"
                      class="form-control"
                      :id="field.name"
                      v-model="field.value"
                      :placeholder="field.title"
                  />

                  <select
                      v-if="field.type === 'dropDown'"
                      class="form-control"
                      :id="field.name"
                      v-model="field.value"
                      :name="field.name"
                  >
                    <option :value="null" selected>Select {{ field.title }}</option>
                    <option v-for="option in field.options" :key="option" :value="option">{{ formatSectionName(option) }}</option>
                  </select>

                  <multiselect
                      v-if="field.type === 'multipleDropDown'"
                      v-model="settlementConfigurations[index]['value']"
                      :options="field.options"
                      :multiple="true"
                      class="shorten-multiselect-option"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :placeholder="'Select ' + field.title"
                      :name="field.name"
                  ></multiselect>

                  <!-- Checkbox Input -->
                  <div class="custom-control custom-switch mb-1" v-if="field.type === 'checkbox'">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="field.name"
                        v-model="settlementConfigurations[index].value"
                    />
                    <label class="custom-control-label" :for="field.name">{{ field.title }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    existingSettings: {
      type: Object,
      default: null
    },
    showSettings: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settlementConfigurations: [],
      loading: false
    };
  },
  watch: {
    showSettings(newVal) {
      if (newVal) {
        this.getConfigurationSettings();
      } else {
        this.settlementConfigurations = [];
      }
    },
    existingSettings(newVal) {
      if (newVal && this.showSettings) {
        this.processResponseData({settlementConfigurations: this.settlementConfigurations});
      }
    }
  },
  methods: {
    getConfigurationSettings(){
      this.loading = true
      this.makeRequest("post", "v1/get-charges-types-data", {channelSettings: 1}, {}, false,true,[205]).then(
          callResponse => {
            this.loading = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = callResponse.response.data.data;
                // For now, use settlementConfigurations from the response
                // Backend will provide different param to return fields directly
                let settingsData = data.channelSettings ? JSON.parse(data.channelSettings) : data;
                this.processResponseData(settingsData);
              }
            }
          }
      );
    },
    processResponseData(data) {
      // Extract settlementConfigurations from the data
      const settlementFields = data.settlementConfigurations || [];
      
      this.settlementConfigurations = settlementFields.map(field => ({
        ...field,
        value: field.type === 'checkbox' ? false :
                  field.type === 'multipleDropDown' ? (field.value || []) :
                      field.value || ''
      }));
      
      // Populate with existing settings if available
      if (this.existingSettings) {
        const existingSettings = this.existingSettings;
        this.settlementConfigurations.forEach(field => {
          if (existingSettings[field.name] !== undefined) {
            field.value = existingSettings[field.name];
          }
        });
      }
    },
    clearAllSettings() {
      this.settlementConfigurations = this.settlementConfigurations.map(field => ({
        ...field,
        value: field.type === 'checkbox' ? false : ''
      }));
    },
    formatSectionName(name) {
      return name
          .replace(/([A-Z])/g, " $1")
          .replace(/_/g, " ")
          .replace(/\b\w/g, c => c.toUpperCase())
          .trim();
    },
    getSettingsData() {
      let rawData = {};
      if(this.showSettings && this.settlementConfigurations.length > 0){
        this.settlementConfigurations.forEach(field => {
          if(field.type === 'checkbox'){
            if(field.value != true){
              return
            }
          }
          if(field.value == '' || field.value == null){
            return;
          }
          rawData[field.name] = field.value;
        });
      }
      return rawData;
    }
  }
};
</script>
